import React, {useEffect} from "react";
import {Form, Row, Col, Divider, Button, Input, Space, Select} from "antd";
import Icon from "assets/icons";
import {useAppSelector} from "redux/hooks";
import {formatDateToString} from "helper/common";
import moment from "moment";
import {FORMAT_TIME} from "types/enums";
const FormList = props => {
  const {index} = props;

  const examRef = useAppSelector(state => state.examination.ref);
  return (
    <Form.List
      name={[
        `${index == 0 ? "rightJsonValue" : "leftJsonValue"}`,
        "CORNEA",
        "FormList",
      ]}
      initialValue={[{input1: "", input2: ""}]}
    >
      {(fields, {add, remove}, {errors}) => (
        <>
          {fields.map((field, idx) => (
            <>
              <Row gutter={[16, 16]} style={{marginTop: 8}}>
                <Col flex={"160px"}>
                  CCT {idx + 1}
                  <span style={{marginLeft: "4px"}}>
                    <Button
                      danger={idx != 0 ? true : false}
                      type="primary"
                      onClick={() => {
                        if (idx == 0) {
                          add({
                            input1: "",
                            input2: "",
                          });
                        } else {
                          remove(idx);
                        }
                      }}
                    >
                      {idx == 0 ? (
                        <Icon.add rev={0}></Icon.add>
                      ) : (
                        <Icon.sub rev={0}></Icon.sub>
                      )}
                    </Button>
                  </span>
                </Col>
                <Col flex={"auto"}>
                  <Space>
                    <Form.Item name={[field.name, "input1"]}>
                      <Input
                        suffix="μm"
                        placeholder="Nhập"
                        onChange={e => {
                          examRef.setFieldValue(
                            [
                              `${
                                index == 0 ? "rightJsonValue" : "leftJsonValue"
                              }`,
                              "CORNEA",
                              "FormList",
                              field.name,
                              "input2",
                            ],
                            formatDateToString(moment(), FORMAT_TIME.dateTime)
                          );
                        }}
                      ></Input>
                    </Form.Item>

                    <Form.Item name={[field.name, "input2"]}>
                      <Input allowClear placeholder="Nhập"></Input>
                    </Form.Item>
                  </Space>
                </Col>
              </Row>
            </>
          ))}
        </>
      )}
    </Form.List>
  );
};
export default FormList;
